
// Icon import'ları
import Skull from '@/assets/emojis/Skull.svg'
import HotFace from '@/assets/emojis/HotFace.svg'
import ColdFace from '@/assets/emojis/ColdFace.svg'
import NerdFace from '@/assets/emojis/NerdFace.svg'
import ZanyFace from '@/assets/emojis/ZanyFace.svg'
import AngryFace from '@/assets/emojis/AngryFace.svg'
import DizzyFace from '@/assets/emojis/DizzyFace.svg'
import LyingFace from '@/assets/emojis/LyingFace.svg'
import TiredFace from '@/assets/emojis/TiredFace.svg'
import WearyFace from '@/assets/emojis/WearyFace.svg'
import WoozyFace from '@/assets/emojis/WoozyFace.svg'
import CryingFace from '@/assets/emojis/CryingFace.svg'
import HushedFace from '@/assets/emojis/HushedFace.svg'
import SleepyFace from '@/assets/emojis/SleepyFace.svg'
import StarStruck from '@/assets/emojis/StarStruck.svg'
import FearfulFace from '@/assets/emojis/FearfulFace.svg'
import FlushedFace from '@/assets/emojis/FlushedFace.svg'
import HuggingFace from '@/assets/emojis/HuggingFace.svg'
import KissingFace from '@/assets/emojis/KissingFace.svg'
import NeutralFace from '@/assets/emojis/NeutralFace.svg'
import PensiveFace from '@/assets/emojis/PensiveFace.svg'
import SmilingFace from '@/assets/emojis/SmilingFace.svg'
import WinkingFace from '@/assets/emojis/WinkingFace.svg'
import WorriedFace from '@/assets/emojis/WorriedFace.svg'
import YawningFace from '@/assets/emojis/YawningFace.svg'
import ConfusedFace from '@/assets/emojis/ConfusedFace.svg'
import DroolingFace from '@/assets/emojis/DroolingFace.svg'
import FaceVomiting from '@/assets/emojis/FaceVomiting.svg'
import FrowningFace from '@/assets/emojis/FrowningFace.svg'
import GrinningFace from '@/assets/emojis/GrinningFace.svg'
import PartyingFace from '@/assets/emojis/PartyingFace.svg'
import PleadingFace from '@/assets/emojis/PleadingFace.svg'
import PoutingFace from '@/assets/emojis/Pouting Face.svg'
import ShushingFace from '@/assets/emojis/ShushingFace.svg'
import SleepingFace from '@/assets/emojis/SleepingFace.svg'
import SmirkingFace from '@/assets/emojis/SmirkingFace.svg'
import SneezingFace from '@/assets/emojis/SneezingFace.svg'
import ThinkingFace from '@/assets/emojis/ThinkingFace.svg'
import UnamusedFace from '@/assets/emojis/UnamusedFace.svg'
import AnguishedFace from '@/assets/emojis/AnguishedFace.svg'
import CowboyHatFace from '@/assets/emojis/CowboyHatFace.svg'
import DisguisedFace from '@/assets/emojis/DisguisedFace.svg'
import ExplodingHead from '@/assets/emojis/ExplodingHead.svg'
import GrimacingFace from '@/assets/emojis/GrimacingFace.svg'
import NauseatedFace from '@/assets/emojis/NauseatedFace.svg'
import RelievedFace from '@/assets/emojis/Relieved Face.svg'
import AstonishedFace from '@/assets/emojis/AstonishedFace.svg'
import ConfoundedFace from '@/assets/emojis/ConfoundedFace.svg'
import FaceWithTongue from '@/assets/emojis/FaceWithTongue.svg'
import MoneyMouthFace from '@/assets/emojis/MoneyMouthFace.svg'
import UpsideDownFace from '@/assets/emojis/UpsideDownFace.svg'
import FaceWithMonocle from '@/assets/emojis/FaceWithMonocle.svg'
import PerseveringFace from '@/assets/emojis/PerseveringFace.svg'
import ZipperMouthFace from '@/assets/emojis/ZipperMouthFace.svg'
import DisappointedFace from '@/assets/emojis/DisappointedFace.svg'
import FaceBlowingaKiss from '@/assets/emojis/FaceBlowingaKiss.svg'
import FaceSavoringFood from '@/assets/emojis/FaceSavoringFood.svg'
import FaceWithoutMouth from '@/assets/emojis/FaceWithoutMouth.svg'
import LoudlyCryingFace from '@/assets/emojis/LoudlyCryingFace.svg'
import FaceWithOpenMouth from '@/assets/emojis/FaceWithOpenMouth.svg'
import AngryFacewithHorns from '@/assets/emojis/AngryFacewithHorns.svg'
import ExpressionlessFace from '@/assets/emojis/ExpressionlessFace.svg'
import FaceWithTearsOfJoy from '@/assets/emojis/FaceWithTearsOfJoy.svg'
import SadButRelievedFace from '@/assets/emojis/SadButRelievedFace.svg'
import SkullandCrossbones from '@/assets/emojis/SkullandCrossbones.svg'
import FaceScreamingInFear from '@/assets/emojis/FaceScreamingInFear.svg'
import FaceWithHeadBandage from '@/assets/emojis/FaceWithHeadBandage.svg'
import FaceWithMedicalMask from '@/assets/emojis/FaceWithMedicalMask.svg'
import FaceWithRollingEyes from '@/assets/emojis/FaceWithRollingEyes.svg'
import FaceWithThermometer from '@/assets/emojis/FaceWithThermometer.svg'
import SlightlySmilingFace from '@/assets/emojis/SlightlySmilingFace.svg'
import SmilingFacewithHalo from '@/assets/emojis/SmilingFacewithHalo.svg'
import SmilingFacewithTear from '@/assets/emojis/SmilingFacewithTear.svg'
import AnxiousFacewithSweat from '@/assets/emojis/AnxiousFacewithSweat.svg'
import SlightlyFrowningFace from '@/assets/emojis/SlightlyFrowningFace.svg'
import SmilingFaceWithHorns from '@/assets/emojis/SmilingFaceWithHorns.svg'
import DowncastFacewithSweat from '@/assets/emojis/DowncastFacewithSweat.svg'
import FaceWithHandOverMouth from '@/assets/emojis/FaceWithHandOverMouth.svg'
import FaceWithRaisedEyebrow from '@/assets/emojis/FaceWithRaisedEyebrow.svg'
import FaceWithSteamFromNose from '@/assets/emojis/FaceWithSteamFromNose.svg'
import GrinningFaceWithSweat from '@/assets/emojis/GrinningFaceWithSweat.svg'
import GrinningSquintingFace from '@/assets/emojis/GrinningSquintingFace.svg'
import SmilingFaceWithHearts from '@/assets/emojis/SmilingFaceWithHearts.svg'
import WinkingFaceWithTongue from '@/assets/emojis/WinkingFaceWithTongue.svg'
import FaceWithSymbolsOnMouth from '@/assets/emojis/FaceWithSymbolsOnMouth.svg'
import GrinningFaceWithBigEyes from '@/assets/emojis/GrinningFaceWithBigEyes.svg'
import SquintingFacewithTongue from '@/assets/emojis/SquintingFacewithTongue.svg'
import SmilingFaceWithHeartEyes from '@/assets/emojis/SmilingFaceWithHeartEyes.svg'
import FrowningFaceWithOpenMouth from '@/assets/emojis/FrowningFaceWithOpenMouth.svg'
import KissingFacewithClosedEyes from '@/assets/emojis/KissingFacewithClosedEyes.svg'

// Icon ID sabitleri
export const ICON_IDS = {
    SKULL: '0001',
    HOT_FACE: '0002',
    COLD_FACE: '0003',
    NERD_FACE: '0004',
    ZANY_FACE: '0005',
    ANGRY_FACE: '0006',
    DIZZY_FACE: '0007',
    LYING_FACE: '0008',
    TIRED_FACE: '0009',
    WEARY_FACE: '0010',
    WOOZY_FACE: '0011',
    CRYING_FACE: '0012',
    HUSHED_FACE: '0013',
    SLEEPY_FACE: '0014',
    STAR_STRUCK: '0015',
    FEARFUL_FACE: '0016',
    FLUSHED_FACE: '0017',
    HUGGING_FACE: '0018',
    KISSING_FACE: '0019',
    NEUTRAL_FACE: '0020',
    PENSIVE_FACE: '0021',
    SMILING_FACE: '0022',
    WINKING_FACE: '0023',
    WORRIED_FACE: '0024',
    YAWNING_FACE: '0025',
    CONFUSED_FACE: '0026',
    DROOLING_FACE: '0027',
    FACE_VOMITING: '0028',
    FROWNING_FACE: '0029',
    GRINNING_FACE: '0030',
    PARTYING_FACE: '0031',
    PLEADING_FACE: '0032',
    POUTING_FACE: '0033',
    SHUSHING_FACE: '0034',
    SLEEPING_FACE: '0035',
    SMIRKING_FACE: '0036',
    SNEEZING_FACE: '0037',
    THINKING_FACE: '0038',
    UNAMUSED_FACE: '0039',
    ANGUISHED_FACE: '0040',
    COWBOY_HAT_FACE: '0041',
    DISGUISED_FACE: '0042',
    EXPLODING_HEAD: '0043',
    GRIMACING_FACE: '0044',
    NAUSEATED_FACE: '0045',
    RELIEVED_FACE: '0046',
    ASTONISHED_FACE: '0047',
    CONFOUNDED_FACE: '0048',
    FACE_WITH_TONGUE: '0049',
    MONEY_MOUTH_FACE: '0050',
    UPSIDE_DOWN_FACE: '0051',
    FACE_WITH_MONOCLE: '0052',
    PERSEVERING_FACE: '0053',
    ZIPPER_MOUTH_FACE: '0054',
    DISAPPOINTED_FACE: '0055',
    FACE_BLOWING_A_KISS: '0056',
    FACE_SAVORING_FOOD: '0057',
    FACE_WITHOUT_MOUTH: '0058',
    LOUDLY_CRYING_FACE: '0059',
    FACE_WITH_OPEN_MOUTH: '0060',
    ANGRY_FACE_WITH_HORNS: '0061',
    EXPRESSIONLESS_FACE: '0062',
    FACE_WITH_TEARS_OF_JOY: '0063',
    SAD_BUT_RELIEVED_FACE: '0064',
    SKULL_AND_CROSSBONES: '0065',
    FACE_SCREAMING_IN_FEAR: '0066',
    FACE_WITH_HEAD_BANDAGE: '0067',
    FACE_WITH_MEDICAL_MASK: '0068',
    FACE_WITH_ROLLING_EYES: '0069',
    FACE_WITH_THERMOMETER: '0070',
    SLIGHTLY_SMILING_FACE: '0071',
    SMILING_FACE_WITH_HALO: '0072',
    SMILING_FACE_WITH_TEAR: '0073',
    ANXIOUS_FACE_WITH_SWEAT: '0074',
    SLIGHTLY_FROWNING_FACE: '0075',
    SMILING_FACE_WITH_HORNS: '0076',
    DOWNCAST_FACE_WITH_SWEAT: '0077',
    FACE_WITH_HAND_OVER_MOUTH: '0078',
    FACE_WITH_RAISED_EYEBROW: '0079',
    FACE_WITH_STEAM_FROM_NOSE: '0080',
    GRINNING_FACE_WITH_SWEAT: '0081',
    GRINNING_SQUINTING_FACE: '0082',
    SMILING_FACE_WITH_HEARTS: '0083',
    WINKING_FACE_WITH_TONGUE: '0084',
    FACE_WITH_SYMBOLS_ON_MOUTH: '0085',
    GRINNING_FACE_WITH_BIG_EYES: '0086',
    SQUINTING_FACE_WITH_TONGUE: '0087',
    SMILING_FACE_WITH_HEART_EYES: '0088',
    FROWNING_FACE_WITH_OPEN_MOUTH: '0089',
    KISSING_FACE_WITH_CLOSED_EYES: '0090'
}

// Icon veritabanı
export const ICON_DATABASE = {
    '0001': Skull,
    '0002': HotFace,
    '0003': ColdFace,
    '0004': NerdFace,
    '0005': ZanyFace,
    '0006': AngryFace,
    '0007': DizzyFace,
    '0008': LyingFace,
    '0009': TiredFace,
    '0010': WearyFace,
    '0011': WoozyFace,
    '0012': CryingFace,
    '0013': HushedFace,
    '0014': SleepyFace,
    '0015': StarStruck,
    '0016': FearfulFace,
    '0017': FlushedFace,
    '0018': HuggingFace,
    '0019': KissingFace,
    '0020': NeutralFace,
    '0021': PensiveFace,
    '0022': SmilingFace,
    '0023': WinkingFace,
    '0024': WorriedFace,
    '0025': YawningFace,
    '0026': ConfusedFace,
    '0027': DroolingFace,
    '0028': FaceVomiting,
    '0029': FrowningFace,
    '0030': GrinningFace,
    '0031': PartyingFace,
    '0032': PleadingFace,
    '0033': PoutingFace,
    '0034': ShushingFace,
    '0035': SleepingFace,
    '0036': SmirkingFace,
    '0037': SneezingFace,
    '0038': ThinkingFace,
    '0039': UnamusedFace,
    '0040': AnguishedFace,
    '0041': CowboyHatFace,
    '0042': DisguisedFace,
    '0043': ExplodingHead,
    '0044': GrimacingFace,
    '0045': NauseatedFace,
    '0046': RelievedFace,
    '0047': AstonishedFace,
    '0048': ConfoundedFace,
    '0049': FaceWithTongue,
    '0050': MoneyMouthFace,
    '0051': UpsideDownFace,
    '0052': FaceWithMonocle,
    '0053': PerseveringFace,
    '0054': ZipperMouthFace,
    '0055': DisappointedFace,
    '0056': FaceBlowingaKiss,
    '0057': FaceSavoringFood,
    '0058': FaceWithoutMouth,
    '0059': LoudlyCryingFace,
    '0060': FaceWithOpenMouth,
    '0061': AngryFacewithHorns,
    '0062': ExpressionlessFace,
    '0063': FaceWithTearsOfJoy,
    '0064': SadButRelievedFace,
    '0065': SkullandCrossbones,
    '0066': FaceScreamingInFear,
    '0067': FaceWithHeadBandage,
    '0068': FaceWithMedicalMask,
    '0069': FaceWithRollingEyes,
    '0070': FaceWithThermometer,
    '0071': SlightlySmilingFace,
    '0072': SmilingFacewithHalo,
    '0073': SmilingFacewithTear,
    '0074': AnxiousFacewithSweat,
    '0075': SlightlyFrowningFace,
    '0076': SmilingFaceWithHorns,
    '0077': DowncastFacewithSweat,
    '0078': FaceWithHandOverMouth,
    '0079': FaceWithRaisedEyebrow,
    '0080': FaceWithSteamFromNose,
    '0081': GrinningFaceWithSweat,
    '0082': GrinningSquintingFace,
    '0083': SmilingFaceWithHearts,
    '0084': WinkingFaceWithTongue,
    '0085': FaceWithSymbolsOnMouth,
    '0086': GrinningFaceWithBigEyes,
    '0087': SquintingFacewithTongue,
    '0088': SmilingFaceWithHeartEyes,
    '0089': FrowningFaceWithOpenMouth,
    '0090': KissingFacewithClosedEyes
}

// Icon kategorileri
export const ICON_CATEGORIES = {
    emotions: [
        { id: '0022', path: SmilingFace, name: 'SmilingFace' },
        { id: '0030', path: GrinningFace, name: 'GrinningFace' },
        { id: '0063', path: FaceWithTearsOfJoy, name: 'FaceWithTearsOfJoy' },
        { id: '0071', path: SlightlySmilingFace, name: 'SlightlySmilingFace' },
        { id: '0081', path: GrinningFaceWithSweat, name: 'GrinningFaceWithSweat' },
        { id: '0082', path: GrinningSquintingFace, name: 'GrinningSquintingFace' },
        { id: '0086', path: GrinningFaceWithBigEyes, name: 'GrinningFaceWithBigEyes' },
        { id: '0031', path: PartyingFace, name: 'PartyingFace' },
        { id: '0015', path: StarStruck, name: 'StarStruck' },
        { id: '0072', path: SmilingFacewithHalo, name: 'SmilingFacewithHalo' },
        { id: '0088', path: SmilingFaceWithHeartEyes, name: 'SmilingFaceWithHeartEyes' },
        { id: '0083', path: SmilingFaceWithHearts, name: 'SmilingFaceWithHearts' },
        { id: '0019', path: KissingFace, name: 'KissingFace' },
        { id: '0056', path: FaceBlowingaKiss, name: 'FaceBlowingaKiss' },
        { id: '0090', path: KissingFacewithClosedEyes, name: 'KissingFacewithClosedEyes' },
        { id: '0018', path: HuggingFace, name: 'HuggingFace' },
        { id: '0012', path: CryingFace, name: 'CryingFace' },
        { id: '0059', path: LoudlyCryingFace, name: 'LoudlyCryingFace' },
        { id: '0029', path: FrowningFace, name: 'FrowningFace' },
        { id: '0075', path: SlightlyFrowningFace, name: 'SlightlyFrowningFace' },
        { id: '0055', path: DisappointedFace, name: 'DisappointedFace' },
        { id: '0021', path: PensiveFace, name: 'PensiveFace' },
        { id: '0064', path: SadButRelievedFace, name: 'SadButRelievedFace' },
        { id: '0073', path: SmilingFacewithTear, name: 'SmilingFacewithTear' },
        { id: '0032', path: PleadingFace, name: 'PleadingFace' },
        { id: '0006', path: AngryFace, name: 'AngryFace' },
        { id: '0061', path: AngryFacewithHorns, name: 'AngryFacewithHorns' },
        { id: '0076', path: SmilingFaceWithHorns, name: 'SmilingFaceWithHorns' },
        { id: '0080', path: FaceWithSteamFromNose, name: 'FaceWithSteamFromNose' },
        { id: '0033', path: PoutingFace, name: 'PoutingFace' },
        { id: '0044', path: GrimacingFace, name: 'GrimacingFace' },
        { id: '0085', path: FaceWithSymbolsOnMouth, name: 'FaceWithSymbolsOnMouth' },
        { id: '0016', path: FearfulFace, name: 'FearfulFace' },
        { id: '0066', path: FaceScreamingInFear, name: 'FaceScreamingInFear' },
        { id: '0024', path: WorriedFace, name: 'WorriedFace' },
        { id: '0074', path: AnxiousFacewithSweat, name: 'AnxiousFacewithSweat' },
        { id: '0040', path: AnguishedFace, name: 'AnguishedFace' },
        { id: '0013', path: HushedFace, name: 'HushedFace' },
        { id: '0047', path: AstonishedFace, name: 'AstonishedFace' },
        { id: '0017', path: FlushedFace, name: 'FlushedFace' },
        { id: '0047', path: AstonishedFace, name: 'AstonishedFace' },
        { id: '0060', path: FaceWithOpenMouth, name: 'FaceWithOpenMouth' },
        { id: '0089', path: FrowningFaceWithOpenMouth, name: 'FrowningFaceWithOpenMouth' },
        { id: '0079', path: FaceWithRaisedEyebrow, name: 'FaceWithRaisedEyebrow' },
        { id: '0043', path: ExplodingHead, name: 'ExplodingHead' },
        { id: '0078', path: FaceWithHandOverMouth, name: 'FaceWithHandOverMouth' },
        { id: '0020', path: NeutralFace, name: 'NeutralFace' },
        { id: '0062', path: ExpressionlessFace, name: 'ExpressionlessFace' },
        { id: '0058', path: FaceWithoutMouth, name: 'FaceWithoutMouth' },
        { id: '0039', path: UnamusedFace, name: 'UnamusedFace' },
        { id: '0036', path: SmirkingFace, name: 'SmirkingFace' },
        { id: '0069', path: FaceWithRollingEyes, name: 'FaceWithRollingEyes' },
        { id: '0038', path: ThinkingFace, name: 'ThinkingFace' },
        { id: '0052', path: FaceWithMonocle, name: 'FaceWithMonocle' },
        { id: '0023', path: WinkingFace, name: 'WinkingFace' },
        { id: '0049', path: FaceWithTongue, name: 'FaceWithTongue' },
        { id: '0084', path: WinkingFaceWithTongue, name: 'WinkingFaceWithTongue' },
        { id: '0087', path: SquintingFacewithTongue, name: 'SquintingFacewithTongue' },
        { id: '0005', path: ZanyFace, name: 'ZanyFace' },
        { id: '0051', path: UpsideDownFace, name: 'UpsideDownFace' },
        { id: '0050', path: MoneyMouthFace, name: 'MoneyMouthFace' },
        { id: '0041', path: CowboyHatFace, name: 'CowboyHatFace' },
        { id: '0004', path: NerdFace, name: 'NerdFace' },
        { id: '0068', path: FaceWithMedicalMask, name: 'FaceWithMedicalMask' },
        { id: '0070', path: FaceWithThermometer, name: 'FaceWithThermometer' },
        { id: '0067', path: FaceWithHeadBandage, name: 'FaceWithHeadBandage' },
        { id: '0045', path: NauseatedFace, name: 'NauseatedFace' },
        { id: '0028', path: FaceVomiting, name: 'FaceVomiting' },
        { id: '0037', path: SneezingFace, name: 'SneezingFace' },
        { id: '0007', path: DizzyFace, name: 'DizzyFace' },
        { id: '0011', path: WoozyFace, name: 'WoozyFace' },
        { id: '0009', path: TiredFace, name: 'TiredFace' },
        { id: '0010', path: WearyFace, name: 'WearyFace' },
        { id: '0014', path: SleepyFace, name: 'SleepyFace' },
        { id: '0035', path: SleepingFace, name: 'SleepingFace' },
        { id: '0025', path: YawningFace, name: 'YawningFace' },
        { id: '0053', path: PerseveringFace, name: 'PerseveringFace' },
        { id: '0077', path: DowncastFacewithSweat, name: 'DowncastFacewithSweat' },
        { id: '0001', path: Skull, name: 'Skull' },
        { id: '0065', path: SkullandCrossbones, name: 'SkullandCrossbones' },
        { id: '0002', path: HotFace, name: 'HotFace' },
        { id: '0003', path: ColdFace, name: 'ColdFace' },
        { id: '0008', path: LyingFace, name: 'LyingFace' },
        { id: '0027', path: DroolingFace, name: 'DroolingFace' },
        { id: '0034', path: ShushingFace, name: 'ShushingFace' },
        { id: '0042', path: DisguisedFace, name: 'DisguisedFace' },
        { id: '0046', path: RelievedFace, name: 'RelievedFace' },
        { id: '0048', path: ConfoundedFace, name: 'ConfoundedFace' },
        { id: '0054', path: ZipperMouthFace, name: 'ZipperMouthFace' },
        { id: '0057', path: FaceSavoringFood, name: 'FaceSavoringFood' },
        { id: '0026', path: ConfusedFace, name: 'ConfusedFace' }
    ]
}

// Varsayılan icon
export const DEFAULT_ICON_ID = '0022'

// Yardımcı fonksiyonlar
export const getIconPath = (iconId) => {
    return ICON_DATABASE[iconId] || ICON_DATABASE[DEFAULT_ICON_ID]
}

export const iconExists = (iconId) => {
    return ICON_DATABASE.hasOwnProperty(iconId)
}

export const getAllIcons = () => {
    return Object.entries(ICON_DATABASE).map(([id, path]) => ({ id, path }))
}

export const getIconsByCategory = (categoryName) => {
    return ICON_CATEGORIES[categoryName] || []
}

export const getAllCategories = () => {
    return Object.keys(ICON_CATEGORIES)
}

export const getIconName = (iconId) => {
    for (const category of Object.values(ICON_CATEGORIES)) {
        const icon = category.find(icon => icon.id === iconId)
        if (icon) return icon.name
    }
    return 'Unknown'
}
